/* src/routes/$layout.svelte generated by Svelte v3.29.7 */
import {
	SvelteComponent,
	claim_component,
	claim_space,
	create_component,
	create_slot,
	destroy_component,
	detach,
	init,
	insert,
	mount_component,
	safe_not_equal,
	space,
	transition_in,
	transition_out,
	update_slot
} from "../../web_modules/svelte/internal.js";

import Nav from "../components/Nav.js";
import PageTransitions from "../components/PageTransitions.js";

function create_default_slot(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[1].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[2], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		l(nodes) {
			if (default_slot) default_slot.l(nodes);
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 4) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[2], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

function create_fragment(ctx) {
	let nav;
	let t;
	let pagetransitions;
	let current;
	nav = new Nav({ props: { segment: /*segment*/ ctx[0] } });

	pagetransitions = new PageTransitions({
			props: {
				refresh: /*segment*/ ctx[0],
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(nav.$$.fragment);
			t = space();
			create_component(pagetransitions.$$.fragment);
		},
		l(nodes) {
			claim_component(nav.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(pagetransitions.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(nav, target, anchor);
			insert(target, t, anchor);
			mount_component(pagetransitions, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const nav_changes = {};
			if (dirty & /*segment*/ 1) nav_changes.segment = /*segment*/ ctx[0];
			nav.$set(nav_changes);
			const pagetransitions_changes = {};
			if (dirty & /*segment*/ 1) pagetransitions_changes.refresh = /*segment*/ ctx[0];

			if (dirty & /*$$scope*/ 4) {
				pagetransitions_changes.$$scope = { dirty, ctx };
			}

			pagetransitions.$set(pagetransitions_changes);
		},
		i(local) {
			if (current) return;
			transition_in(nav.$$.fragment, local);
			transition_in(pagetransitions.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(nav.$$.fragment, local);
			transition_out(pagetransitions.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(nav, detaching);
			if (detaching) detach(t);
			destroy_component(pagetransitions, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	let { segment } = $$props;

	$$self.$$set = $$props => {
		if ("segment" in $$props) $$invalidate(0, segment = $$props.segment);
		if ("$$scope" in $$props) $$invalidate(2, $$scope = $$props.$$scope);
	};

	return [segment, slots, $$scope];
}

class $layout extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { segment: 0 });
	}
}

export default $layout;
//# sourceMappingURL=$layout.js.map
